// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pricing_wrapper__11zkv"};